import { Box, Button, ClickAwayListener, MenuItem, MenuList, Popper, Typography, useTheme } from '@mui/material'
import { observer } from 'mobx-react'
import { useMemo, useRef, useState } from 'react'
import { Icons } from '../utils/utilities'
import { by639_1 } from 'iso-language-codes'
import { useTranslation } from 'react-i18next'

const GlobalLanguageSelector = ( { variant = "outlined" } ) => {

    const [languageOptionsOpen, setLanguageOptionsOpen] = useState( false )

    const { palette, shadows } = useTheme()
    const { i18n, t } = useTranslation()

    const buttonStyles = useMemo( () => {
        if ( variant === "outlined" )
            return { borderRadius: "10px", border: `1px solid ${palette.text.secondary}`, background: "none", color: palette.text.primary }
        if ( variant === "dark" )
            return { borderRadius: "10px", border: `1px solid ${palette.primary.main}`, background: palette.primary.main, color: palette.primary.contrastText }
        else
            return { borderRadius: "10px", bgcolor: palette.common.white, color: palette.common.black }
    }, [variant] )


    const languageOptionsButtonRef = useRef()
    const languageSelectorRef = useRef()

    const languages = ["en", "uz", "ru"]
    const language = i18n.language


    const handleLanguageChange = ( lang ) => {
        i18n.changeLanguage( lang || "cimode" )
        localStorage.setItem( "preferedLanguage", lang )
    }

    return (
        <Box ref={languageSelectorRef}>

            <Popper sx={{ zIndex: 100 }} container={languageSelectorRef.current} placement='bottom-start' open={languageOptionsOpen} anchorEl={languageOptionsButtonRef.current} >
                <ClickAwayListener onClickAway={() => setLanguageOptionsOpen( false )}>
                    <Box boxShadow={shadows[1]} marginTop="5px" borderRadius="5px" overflow="clip" bgcolor={palette.background.paper}>
                        <MenuList dense>
                            {languages.map( lang => {
                                const languageDetails = by639_1[lang.toLowerCase()]
                                return (
                                    <MenuItem dense onClick={() => handleLanguageChange( lang )} selected={lang === language} key={lang}>
                                        <Typography fontSize="14px" component="span" color={lang === language ? palette.primary.contrastText : palette.common.black}>{lang.toUpperCase()} {languageDetails?.nativeName ? `- ${languageDetails?.nativeName}` : ""}</Typography>
                                    </MenuItem>
                                )
                            } )}
                        </MenuList>
                    </Box>
                </ClickAwayListener>
            </Popper>
            <Button endIcon={Icons.default.KeyboardArrowDownIcon} onClick={() => setLanguageOptionsOpen( true )} ref={languageOptionsButtonRef} variant='contained' size='small' disableElevation sx={buttonStyles} startIcon={Icons.default.Language}>
                {t( "label.language" )}: {language?.toUpperCase()}
            </Button>

        </Box>
    )
}

export default GlobalLanguageSelector